import gql from 'graphql-tag';

export const THIRTY_DAY = gql`
    query ThirtyDay($ticker: String!) {
        fund: mutualFund(ticker: $ticker) {
            thirtyDayAnnualizedDividendYieldAsOfDate
            thirtyDayAnnualizedDividendYield
            unsubsidizedThirtyDaySECYieldAsOfDate
            unsubsidizedThirtyDaySECYield
            yield30DayStandard
            yield30DayStandardEffectiveDate
            standardPerformanceReturns {
                quarterlyAnnualReturns {
                    fundPerformance {
                        asOfDate
                    }
                }
            }
        }
    }
`;

export const SEVEN_DAY = gql`
    query SevenDay($ticker: String!) {
        fund: mutualFund(ticker: $ticker) {
            sevenDayAnnualizedDividendYieldCompound
            sevenDayYieldSimple
            unsubsidizedSevenDayYieldCompound
            unsubsidizedSevenDayYieldSimple
            sevenDayYieldSimpleAsOfDate
            standardPerformanceReturns {
                quarterlyAnnualReturns {
                    fundPerformance {
                        asOfDate
                    }
                }
            }
        }
    }
`;

export const FI_ETF_THIRTY_DAY = gql`
    query ThirtyDay($ticker: String!) {
        fund: exchangeTradedFund(ticker: $ticker) {
            thirtyDaySECDividend
            thirtyDaySECDividendAsOfDate
            unsubsidizedThirtyDaySECYield
            unsubsidizedThirtyDaySECYieldAsOfDate
            averageAnnualTotalReturns {
                quarterly {
                    asOfDate
                }
            }
        }
    }
`;

export const THIRTY_DAY_PRTIX = gql`
    query ThirtyDayPRTIX($theCompareTicker: String!) {
        mutualFund(ticker: $theCompareTicker) {
            thirtyDayAnnualizedDividendYieldAsOfDate
            thirtyDayAnnualizedDividendYield
            unsubsidizedThirtyDaySECYieldAsOfDate
            unsubsidizedThirtyDaySECYield
            yield30DayStandard
            yield30DayStandardEffectiveDate
            inceptionDate
        }
    }
`;
